// extracted by mini-css-extract-plugin
module.exports = {"col":"TableCell_col__yEdQv","withEllipsis":"TableCell_withEllipsis__xKLtw","bold":"TableCell_bold__mHsjR","expandable":"TableCell_expandable__FUOhi"};